// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"717":"04e63f75","787":"667f507e"}[chunkId] + ".chunk.js";
};